/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
// @material-ui/core components
import { red } from '@material-ui/core/colors';
import axios from 'axios';
import clsx from 'clsx';
import {
    TextField,
    Button,

    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper, TableSortLabel, TableFooter, TablePagination,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core';

import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import Typography from "@material-ui/core/Typography";
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';

import {
     Modal, ModalHeader, ModalBody, ModalFooter,
    FormGroup, Label, Input,
    Row,
  InputGroupAddon,
  InputGroupText,
  InputGroup
} from 'reactstrap';

// core components
import Grid from "components/Grid/GridContainer";

import Col from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardContent from "@material-ui/core/CardContent";
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import CardHeader from "components/Card/CardHeader.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button2 from "components/CustomButtons/Button.js";
import { authHeader } from "_helpers";
import TSText from "components/Forms/TSText";
import TSSelect2 from "components/Forms/TSSelect2";
import TSUser from "components/Forms/TSUser"; 
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css"
import "./custom-style.css";
import { color } from "highcharts";

const useStyles = makeStyles((theme) => ({
    cardCategoryWhite: {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
      flexGrow: 1,
    },
    cardTitle: {
      textAlign: 'center'
    },
    cardTitleWhite: {
      color: "#FFFFFF",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontFamily: '"Sarabun", sans-serif',
      marginBottom: "3px",
      textDecoration: "none",
      flexGrow: 1,
    },
    collaps:{
      paddingLeft:'40px', 
      paddingTop:'40px',    
      display: 'flex',
      flexDirection: 'column-reverse',
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
      ...StyleSheet.absoluteFillObject,
      alignSelf: 'flex-end',
      position: 'absolute', // add if dont work with above
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    visible: {
        opacity: 1,
        transition: 'opacity 0.5s ease'
    },
    hidden: {
        opacity: 0,
        transition: 'opacity 0.5s ease'
    },
    avatar: {
      backgroundColor: red[500],
    },
    tableContainer: {
        width: '99.99%',
        overflowX: 'auto', // ทำให้ตารางสามารถเลื่อนในแนวนอนเมื่อกว้างเกินไป
      },
    tableRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    tableCell: {
        padding: '2px',
    },
    modalFullscreen: {
        width: '100%',
        height: '100%',
        margin: 0,
        maxWidth: '100%',
      },
      modalContent: {
        height: '100%',
        borderRadius: 0,
      },
      modalBody: {
        overflowY: 'auto',
      },
      pagination: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
    cardXs: {
        width: 75,
        height: 110,
        paddingTop: 10,
        margin: 2,
        textAlign: 'center',
        margin: "3px",
        transition: "0.3s",
        display: "inline-block",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
        }
    },
    cardSm: {
        width: 180,
        height: 140,
        textAlign: 'center',
        margin: "3px",
        transition: "0.3s",
        display: "inline-block",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
        }
    },
    cardImg1: {
        width: 60, height: 60, borderRadius: 60 / 2, objectFit: 'cover', objectPosition: '100% 0'
    },
    cardImg2: {
        width: 100, height: 100, borderRadius: 100 / 2, objectFit: 'cover', objectPosition: '100% 0'
    },
  }));


const AssetList = (props) => {
    const host = '';//'https://e.trangskin.go.th'; 
    var moment = require('moment');
    require('moment/locale/th');
    const classes = useStyles();

    const [assets, setAssets] = useState([]);

    //page & order
    const [orderDirection, setOrderDirection] = useState('desc');
    const [orderBy, setOrderBy] = useState('calYear'); // default column to sort
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);


    const [expanded, setExpanded] = React.useState(false);

    const [isEditing, setIsEditing] = useState(false);
    const [editIndex, setEditIndex] = useState(null);

    const [selectedAsset, setSelectedAsset] = useState(null);

    const [ArrDocno, setArrDocno] = useState([""]);
    const [ArrAssetType, setAssetType] = useState([]); 
    const [ArrCategory, setCategory] = useState([]);
    const [ArrBrand, setBrand] = useState([]);
    const [ArrPlace, setPlace] = useState([]); 
    const [ArrCompany, setCompany] = useState([]); 
    const [ArrTMoney, setTMoney] = useState([]); 
    const [ArrKMoney, setKMoney] = useState([]); 

    const ArrAssetStatus = [
        { value: 1, label: 'ใช้งานปกติ', color:'black' },
        { value: 2, label: 'อยู่ในระหว่างการซ่อม', color:'orange'  },
        { value: 3, label: 'ชำรุด', color:'red'  },
        { value: 4, label: 'จำหน่าย', color:'red'  },
        { value: 5, label: 'อยู่ในระหว่างรอจำหน่าย', color:'orange'  },
        { value: 6, label: 'หาไม่เจอ', color:'red'  },
    ];

    const ArrPeriod = [
        { value: 'd', label: 'วัน' },
        { value: 'm', label: 'เดือน' },
        { value: 'y', label: 'ปี' },
    ];

    const [TypeKey, setTypeKey] = useState(4);
    const [CategoryKey, setCategoryKey] = useState(0);
    const [BrandKey, setBrandKey] = useState(0);
    const [CompanyKey, setCompanyKey] = useState(0);
    const [TMoneyKey, setTMoneyKey] = useState(0);
    const [KMoneyKey, setKMoneyKey] = useState(0);
    const [Keyword, setKeyword] = useState('');

    const [ArrCategory2, setCategory2] = useState([]); 

    const [Attendee, setAttendee] = useState([]);
    const [toggleEdit, setToggleEdit] = useState(false);

    const [modalOpen, setModalOpen] = useState(false);
    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [modalError, setModalError] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");
    const [dateFocus, setDateFocus] = useState(false);

    useEffect(() => {

        axios(host+"/api/v1/asset/assettype")
        .then(
          result => {
                var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"typeKey":').join('"value":'));
                setAssetType(json)
            }, error => { console.log(error); }
        );  

        axios(host+"/api/v1/asset/brand")
        .then(
          result => {
                var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"brandKey":').join('"value":'));
                setBrand(json)
            }, error => { console.log(error); }
        );  

        axios(host + "/api/v1/asset/place")
            .then(
                result => {
                    var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"placeKey":').join('"value":'));
                    setPlace(json)
                }, error => { console.log(error); }
        );  

        axios(host+"/api/v1/asset/company")
        .then(
          result => {
                var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"companyKey":').join('"value":'));
                setCompany(json)
            }, error => { console.log(error); }
        );  

        axios(host+"/api/v1/asset/tmoney")
        .then(
          result => {
                var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"tmoneyKey":').join('"value":'));
                setTMoney(json)
            }, error => { console.log(error); }
        );  

        axios(host+"/api/v1/asset/kmoney")
        .then(
          result => {
                var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"kmoneyKey":').join('"value":'));
                setKMoney(json)
            }, error => { console.log(error); }
        );  

    }, []);

    useEffect(() => {
        fetchCatgory(TypeKey);
    }, [TypeKey]);

    useEffect(() => {
        fetchAssets();
    }, [TypeKey, CategoryKey, Keyword]);

    const fetchCatgory = async () => {
        try {
            const response = await axios.get(host+'/api/v1/asset/category?typeKey='+TypeKey);
            var json = JSON.parse(JSON.stringify(response.data.data).split('"name":').join('"label":').split('"categoryKey":').join('"value":'));
           
            if(response.data.result == 200)
                setCategory(json)
            else
                setCategory([]);
            
        } catch (error) {
            console.error('Error fetching assets:', error);
            setCategory([]);
        }
    };

    const fetchCatgory2 = async (type2) => {
        try {
            const response = await axios.get(host+'/api/v1/asset/category?typeKey='+type2);
            var json = JSON.parse(JSON.stringify(response.data.data).split('"name":').join('"label":').split('"categoryKey":').join('"value":'));
           
            if(response.data.result == 200)
                setCategory2(json)
            else
                setCategory2([]);
            
        } catch (error) {
            console.error('Error fetching assets:', error);
            setCategory2([]);
        }
    };

    const fetchAssets = async () => {
        try {
            const response = await axios.get(host+'/api/v1/asset?name='+Keyword+'&typeKey='+TypeKey+'&categoryKey='+CategoryKey);
            if (response.data.result == 200) {          
                setAssets(response.data.data);
            }    
            else
                setAssets([]);
        } catch (error) {
            console.error('Error fetching assets:', error);
            setAssets([]);
        }
    };


    //set ค่าใน textbox DocNo
    const handleDocnoChange = (e, index) => {
        const newArrDocno = [...ArrDocno];
        newArrDocno[index] = e.target.value; // Update the input value
        setArrDocno(newArrDocno);
    };

    //เพิ่ม textbox แบบ list
    const addDocnoInput = () => {
        setArrDocno([...ArrDocno, ""]); // Add an empty string for the new input
    };

    //Remove textbox 
    const removeDocnoInput = (index) => {
        const newArrDocno = ArrDocno.filter((_, i) => i !== index); // Filter out the input at the given index
        setArrDocno(newArrDocno);
    };

 


    //เมื่อปิด Modal
    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedAsset(null);

        setIsEditing(false);
        setEditIndex(null);
    };

    const handleExpand = () => {
        console.log(expanded)
        setExpanded(!expanded)
    }

    //----------------table function----------------
    //page order
    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && orderDirection === 'asc';
        setOrderDirection(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
      };
    
    const sortedAssets = () => {
        return assets.sort((a, b) => {
          if (orderDirection === 'asc') {
            return a[orderBy] < b[orderBy] ? -1 : 1;
          }
          return a[orderBy] > b[orderBy] ? -1 : 1;
        });
    };
    
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    //----------------table function----------------




    //กดเพื่อแก้ไขข้อมูลเดิม  Edit Asset Click
    const handleEdit = (index, _asset) => {
        //const assetToEdit = assets[index];
        const assetToEdit = _asset;
        setEditIndex(index);
        setIsEditing(true);

        setSelectedAsset(assetToEdit);
        fetchCatgory2(assetToEdit.typeKey);

        var _rAttendee = [];
        setAttendee(_rAttendee);
        //assetToEdit.userView['attendStatusKey'] = 0;



        setModalOpen(true);

        if (assetToEdit.userView !== null) {
            _rAttendee.push(assetToEdit.userView);
            setAttendee(_rAttendee)
            setExpanded(false)
        }
        else {
            setExpanded(true)
        }
    };

    //กดเพื่อเพิ่มข้อมูลใหม่ Insert Asset Button Click
    const handleAdd = () => {
        clearForm();
        setModalOpen(true);
    };

    //Clear form input
    const clearForm = () => {
        var nullData = {
            //assetKey: null,
            docNo: null,
            groupId: null,
            name: null,
            assetMode: null,
            serialNo: null,
            typeKey: null,
            typeCode: null,
            categoryKey: null,
            categoryCode: null,
            brandKey: null,
            modelName: null,
            placeKey: null,
            placeCode: null,
            placeCode2: null,
            calYear: null,
            receiveDate: null,
            receiveDocNo: null,
            period: null,
            periodUnit: null,
            periodYear: null,
            expiredDate: null,
            kmoneyKey: null,
            kmoneyCode: null,
            tmoneyKey: null,
            tmoneyCode: null,
            price: null,
            deprec: null,
            deprecYear: null,
            description: null,
            companyKey: null,
            departmentKey: null,
            userCode: null,
            dpsDocNo: null,
            dpsDocDate: null,
            dpsApproveDate: null,
            assetStatusKey: null,
            pmStatus: null,
            calStatus: null,
            riskStatus: null,
            warrantyStartDate: null,
            warantyPeriodUnit: null,
            warantyPeriodYear: null,
            warantyExpiredDate: null,
            checkerCode: null,
            checkerDatetime: null,
            imageFile: null,
            imageName: null,
            imageType: null,
            imageSize: null,
            image: null,
            creatorCode: null,
            createDatetime: null,
            lastEditerCode: null,
            lastEditDatetime: null,
            assetType: null,
            category: null,
            userView: null
        }

        setSelectedAsset(nullData);

        setArrDocno([""]);
    };

    //on value change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSelectedAsset({ ...selectedAsset, [name]: value });
    };
    //on selected change
    const handleSelectChange = (name, value) => {
        if (name == 'typeKey')
            fetchCatgory2(value);

        setSelectedAsset({ ...selectedAsset, [name]: value });
    };
    //เมื่อเลือกเจ้าหน้าที่
    const handleEmployeeChange = (_val) => {

        setToggleEdit(false);
        setAttendee(_val)

        setSelectedAsset({ ...selectedAsset, ["userCode"]: _val[0].userName });

        setExpanded(false);
    }

    const handleSaveChanges = async () => {
        try {
            console.log('/api/v1/asset/' + selectedAsset.assetKey)

            console.log(selectedAsset)
            if (isEditing) {
                await axios.put(host + '/api/v1/asset/' + selectedAsset.assetKey, selectedAsset);
            }
            else {
                selectedAsset.docNo = JSON.stringify(ArrDocno);
                await axios.post(host + '/api/v1/asset/', selectedAsset);
            }

            handleCloseModal();
            setIsEditing(false);
            setEditIndex(null);

            // Refresh the asset list after updating
            const response = await axios.get(host + '/api/v1/asset?name=' + Keyword + '&typeKey=' + TypeKey + '&categoryKey=' + CategoryKey);
            setAssets(response.data.data);

        } catch (error) {
            console.error("Error updating asset:", error);
        }
    };

    return (
        <div>
            <Grid>
                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary">

                            <h4 className={classes.cardTitleWhite}>รายการครุภัณฑ์</h4>
                            <p className={classes.cardCategoryWhite}></p>

                        </CardHeader>
                        <CardBody>
                           
                            <div>
                                <Grid>
                                    <Col xs={12} sm={12} md={12}>
                                        <TSText icon="far fa-edit" label="คำค้นหา" value={Keyword} onChange={e => setKeyword(e.target.value)} />
                                    </Col> 
                                   <Col xs={12} sm={12} md={6}>
                                        <TSSelect2 isClearable={true} label="TypeKey" options={ArrAssetType} value={TypeKey} onChange={e => setTypeKey(e != null ? e.value : '') } />
                                    </Col> 
                                    <Col xs={12} sm={12} md={6}>
                                        <TSSelect2 isClearable={true} label="CategoryKey" options={ArrCategory} value={CategoryKey} onChange={e => setCategoryKey(e != null ? e.value : '') } />
                                    </Col> 

                                </Grid>
                                
                                {/* Add more fields as necessary for other properties */}
                                <Col xs={12} sm={12} md={12} style={{textAlign:'right'}}>
                                    
                                    <Button2
                                        color="success"
                                        type="button"
                                        onClick={handleAdd}
                                    >
                                        <h4><i className={"fa fa-plus"}> เพิ่มครุภัณฑ์</i></h4>
                                    </Button2>

                                </Col>
                                <TableContainer component={Paper} className={classes.tableContainer}>
                                    <Table className={classes.table} aria-label="asset table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    <TableSortLabel
                                                        active={orderBy === 'docNo'}
                                                        direction={orderBy === 'docNo' ? orderDirection : 'asc'}
                                                        onClick={() => handleRequestSort('docNo')}
                                                    >   
                                                         เลขครุภัณฑ์     
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell>
                                                    <TableSortLabel
                                                        active={orderBy === 'name'}
                                                        direction={orderBy === 'name' ? orderDirection : 'asc'}
                                                        onClick={() => handleRequestSort('name')}
                                                    >   
                                                         ชื่อรายการ     
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell style={{ display: (TypeKey == 0 ?'table-cell':'none')}}>
                                                    <TableSortLabel
                                                        active={orderBy === 'typeKey'}
                                                        direction={orderBy === 'typeKey' ? orderDirection : 'asc'}
                                                        onClick={() => handleRequestSort('typeKey')}
                                                    >   
                                                         ประเภทครุภัณฑ์     
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell style={{ display: (CategoryKey == 0 ? 'table-cell' : 'none') }}>
                                                    <TableSortLabel
                                                        active={orderBy === 'categoryKey'}
                                                        direction={orderBy === 'categoryKey' ? orderDirection : 'asc'}
                                                        onClick={() => handleRequestSort('categoryKey')}
                                                    >   
                                                         หมวดครุภัณฑ์     
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell>
                                                    <TableSortLabel
                                                        active={orderBy === 'calYear'}
                                                        direction={orderBy === 'calYear' ? orderDirection : 'asc'}
                                                        onClick={() => handleRequestSort('calYear')}
                                                    >   
                                                        ปีงบประมาณ     
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell>
                                                    <TableSortLabel
                                                        active={orderBy === 'assetStatusKey'}
                                                        direction={orderBy === 'assetStatusKey' ? orderDirection : 'asc'}
                                                        onClick={() => handleRequestSort('assetStatusKey')}
                                                    >   
                                                        สถานะ     
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell>
                                                    <TableSortLabel
                                                        active={orderBy === 'userCode'}
                                                        direction={orderBy === 'userCode' ? orderDirection : 'asc'}
                                                        onClick={() => handleRequestSort('userCode')}
                                                    >
                                                        รับผิดชอบ
                                                    </TableSortLabel>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {//assets.map((asset, index) => (
                                            sortedAssets()
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((asset, index) => (
                                                <TableRow key={index} className={classes.tableRow}>
                                                    <TableCell className={classes.tableCell}><Button style={{ textDecoration: 'underline' }} onClick={() => handleEdit(index, asset)}>{asset.docNo}</Button></TableCell>
                                                    <TableCell className={classes.tableCell}><Button style={{ textDecoration: 'underline' }} onClick={() => handleEdit(index, asset)}>{asset.name}</Button></TableCell>
                                                    <TableCell style={{ display: (TypeKey == 0 ? '' : 'none') }} className={classes.tableCell}>{asset.assetType.name}</TableCell>
                                                    <TableCell style={{ display: (CategoryKey == 0 ? '' : 'none') }}  className={classes.tableCell}>{asset.category.name}</TableCell>
                                                    <TableCell className={classes.tableCell}>{asset.calYear}</TableCell>
                                                    <TableCell className={classes.tableCell} style={{ color: (asset.assetStatusKey != null && ArrAssetStatus.find(t => t.value == asset.assetStatusKey)!=null)  ? ArrAssetStatus.find(t => t.value == asset.assetStatusKey).color : 'black'}} >{ (asset.assetStatusKey != null && ArrAssetStatus.find(t => t.value == asset.assetStatusKey)!=null)  ? ArrAssetStatus.find(t => t.value == asset.assetStatusKey).label : ''}</TableCell>
                                                    <TableCell className={classes.tableCell}>{asset.userView?.firstName} {asset.userView?.lastName}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        <TableFooter>
                                        <TableRow>
                                            <TablePagination
                                            rowsPerPageOptions={[5, 10, 25]}
                                            count={assets.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            />
                                        </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </div>

                        </CardBody>
                        <CardFooter>
                            <Modal isOpen={modalOpen} toggle={handleCloseModal} className={classes.modalFullscreen}>
                                <ModalHeader toggle={handleCloseModal}></ModalHeader>
                                <ModalBody>
                                {selectedAsset && (
                                    <Card>
                                        {(isEditing) ?
                                        <CardHeader color="primary">

                                            <h4 className={classes.cardTitleWhite}>{selectedAsset.name}</h4>
                                            <p className={classes.cardCategoryWhite}>{selectedAsset.docNo}</p>

                                        </CardHeader>
                                        : 
                                        <CardHeader color="primary">
                                            <h4 className={classes.cardTitleWhite}>เพิ่มครุภัณฑ์</h4>
                                            <p className={classes.cardCategoryWhite}></p>
                                        </CardHeader>
                                        }
                                        <CardBody>
                                            <Grid>

                                                {(isEditing) ?
                                                        <>
                                                            <Col xs={12} sm={3} md={3}>
                                                                <p>เลขครุภัณฑ์</p>
                                                                <Label>{selectedAsset.docNo}</Label>
                                                            </Col>
                                                            <Col xs={12} sm={9} md={9}>
                                                                <TSText icon="far fa-edit" name="name" label="ชื่อครุภัณฑ์" value={selectedAsset.name} onChange={e => handleInputChange(e)} />
                                                            </Col>
                                                        </>
                                                        :
                                                        <>
                                                              <Col xs={12} sm={12} md={12} >
                                                                <Label>เลขที่ครุภัณฑ์</Label>     
                                                              </Col>
                                                              {ArrDocno.map((input, index) => (
                                                              <Col xs={12} sm={6} md={4} lg={3} key={index}> 
                                                                    <div>
                                                                        <InputGroup  style={{border: (false) ? "solid red":"" }}>
                                                                            {index > 0 ?
                                                                            <InputGroupAddon addonType="prepend">
                                                                              <InputGroupText style={{ borderRadius: "0", padding: "10px 10px" }}>
                                                                                <i style={{ color:'red', cursor: 'pointer' }} className={"fa fa-trash"} onClick={() => removeDocnoInput(index)} ></i>         
                                                                              </InputGroupText>
                                                                            </InputGroupAddon>
                                                                            :
                                                                            <></>
                                                                            }
                                                                            <Input
                                                                              style={{ borderRadius: "0" /*, fontSize: this.state.fontSize*/ }}
                                                                              placeholder={`เลขที่ ${index + 1}`}
                                                                              type="text"
                                                                              value={input}
                                                                              onChange={(e) => handleDocnoChange(e, index)}
                                                                            /> 
                                                                            {index == ArrDocno.length-1 ?
                                                                            <InputGroupAddon addonType="prepend">
                                                                              <InputGroupText style={{ borderRadius: "0", padding: "10px 10px" }}>                                                                                 
                                                                                <i style={{ color:'green', cursor: 'pointer' }} className={"fa fa-plus"} onClick={addDocnoInput}></i>     
                                                                              </InputGroupText>
                                                                            </InputGroupAddon>
                                                                            :
                                                                            <></>
                                                                            }
                                                                        </InputGroup>
                                                                    </div>
                                                              </Col>
                                                              ))}
                                                        </>          
                                                }
                                                
                                                <Col xs={12} sm={12} md={12}>
                                                    <TSText
                                                          icon="far fa-edit"
                                                          name="name"
                                                          label="ชื่อครุภัณฑ์"
                                                          value={selectedAsset.name}
                                                          onChange={(e) => handleInputChange(e)}
                                                    />
                                                </Col>

                                                <Col xs={12} sm={6} md={6}>
                                                    <TSSelect2 name="typeKey" label="ประเภทครุภัณฑ์" options={ArrAssetType} value={selectedAsset.typeKey ?? ''} onChange={e => handleSelectChange('typeKey', (e != null ? e.value : '')) } />
                                                </Col>
                                                <Col xs={12} sm={6} md={6}>
                                                    <TSSelect2 name="categoryKey" label="หมวดครุภัณฑ์" options={ArrCategory2} value={selectedAsset.categoryKey ?? ''} onChange={e => handleSelectChange('categoryKey', (e != null ? e.value : '')) } />
                                                </Col>

                                                <Col xs={12} sm={4} md={4}>
                                                    <TSSelect2 label="ยี่ห้อ" options={ArrBrand} value={selectedAsset.brandKey ?? ''} onChange={e => handleSelectChange('brandKey', (e != null ? e.value : '')) } />
                                                </Col>
                                                <Col xs={12} sm={4} md={4}>
                                                    <TSText icon="far fa-edit" name="modelName" label="รุ่น" value={selectedAsset.modelName} onChange={e => handleInputChange(e)} />
                                                </Col>
                                                <Col xs={12} sm={4} md={4}>
                                                    <TSText icon="far fa-edit" name="serialNo" label="SerialNo" value={selectedAsset.serialNo} onChange={e => handleInputChange(e)} />
                                                </Col>

                                                <Col xs={12} sm={4} md={4}>
                                                        <Label>วันที่รับ</Label>
                                                        <FormGroup
                                                            style={{ padding: '0 0px', marginBottom: '10px' }}
                                                            className={
                                                                "input-lg" + (/*dateFocus*/false ? " input-group-focus" : "")
                                                            }
                                                        >
                                                            <i className="far fa-calendar-check fa-2x" style={{
                                                                position: 'absolute',
                                                                padding: '5px 0 0 10px',
                                                                zIndex: 1,

                                                            }}
                                                            ></i>

                                                            <Datetime
                                                                value={moment(selectedAsset.receiveDate).isValid() ? moment(selectedAsset.receiveDate) : null}
                                                                renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}
       
                                                                inputProps={{
                                                                    name: "receiveDate", placeholder: "วันที่รับ", readOnly: 'readonly'
                                                                    , style: {
                                                                        fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000'
                                                                    },
                                                                    value: moment(selectedAsset.receiveDate).isValid() ? moment(selectedAsset.receiveDate).format('D MMMM BBBB') : ''
                                                                }}
                                                                closeOnSelect={true}
                                                                closeOnTab={true}
                                                                dateFormat="D MMMM BBBB" timeFormat={false}
                                                                onFocus={() => setDateFocus(true)}
                                                                onBlur={() => setDateFocus(false)}
                                                                onChange={e => handleSelectChange('receiveDate', (e != null ? e.format('YYYY-MM-DD') : ''))}

                                                            />
                                                        </FormGroup>
                                                </Col>
                                                <Col xs={6} sm={2} md={2} >
                                                    <TSText icon="far fa-edit" name="period" label="อายุการใข้งาน" value={selectedAsset.period} onChange={e => handleInputChange(e)} />
                                                </Col>
                                                <Col xs={6} sm={2} md={2} >
                                                    <TSSelect2 label="หน่วย" options={ArrPeriod} value={selectedAsset.periodUnit ?? ''} onChange={e => handleSelectChange('periodUnit', (e != null ? e.value : '')) } /> 
                                                </Col>
                                                <Col xs={12} sm={4} md={4}>
                                                    <Label>วันครบอายุ</Label>
                                                    <FormGroup
                                                            style={{ padding: '0 0px', marginBottom: '10px' }}
                                                            className={
                                                                "input-lg" + (/*dateFocus*/false ? " input-group-focus" : "")
                                                            }
                                                        >
                                                            <i className="far fa-calendar-check fa-2x" style={{
                                                                position: 'absolute',
                                                                padding: '5px 0 0 10px',
                                                                zIndex: 1,

                                                            }}
                                                            ></i>

                                                            <Datetime
                                                                value={moment(selectedAsset.expiredDate).isValid() ? moment(selectedAsset.expiredDate) : null}
                                                                renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}
       
                                                                inputProps={{
                                                                    name: "expiredDate", placeholder: "วันครบอายุ", readOnly: 'readonly'
                                                                    , style: {
                                                                        fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000'
                                                                    },
                                                                    value: moment(selectedAsset.expiredDate).isValid() ? moment(selectedAsset.expiredDate).format('D MMMM BBBB') : ''
                                                                }}
                                                                closeOnSelect={true}
                                                                closeOnTab={true}
                                                                dateFormat="D MMMM BBBB" timeFormat={false}
                                                                onFocus={() => setDateFocus(true)}
                                                                onBlur={() => setDateFocus(false)}
                                                                onChange={e => handleSelectChange('expiredDate', (e != null ? e.format('YYYY-MM-DD') : ''))}

                                                            />
                                                    </FormGroup>
                                                </Col>

                                                <Col xs={12} sm={4} md={4}>
                                                        <Label>วันที่ประกัน</Label>
                                                        <FormGroup
                                                            style={{ padding: '0 0px', marginBottom: '10px' }}
                                                            className={
                                                                "input-lg" + (/*dateFocus*/false ? " input-group-focus" : "")
                                                            }
                                                        >
                                                            <i className="far fa-calendar-check fa-2x" style={{
                                                                position: 'absolute',
                                                                padding: '5px 0 0 10px',
                                                                zIndex: 1,

                                                            }}
                                                            ></i>

                                                            <Datetime
                                                                value={moment(selectedAsset.warrantyStartDate).isValid() ? moment(selectedAsset.warrantyStartDate) : null}
                                                                renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}

                                                                inputProps={{
                                                                    name: "warrantyStartDate", placeholder: "วันที่ประกัน", readOnly: 'readonly'
                                                                    , style: {
                                                                        fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000'
                                                                    },
                                                                    value: moment(selectedAsset.warrantyStartDate).isValid() ? moment(selectedAsset.warrantyStartDate).format('D MMMM BBBB') : ''
                                                                }}
                                                                closeOnSelect={true}
                                                                closeOnTab={true}
                                                                dateFormat="D MMMM BBBB" timeFormat={false}
                                                                onFocus={() => setDateFocus(true)}
                                                                onBlur={() => setDateFocus(false)}
                                                                onChange={e => handleSelectChange('warrantyStartDate', (e != null ? e.format('YYYY-MM-DD') : ''))}

                                                            />
                                                        </FormGroup>
                                                </Col>
                                                <Col xs={6} sm={2} md={2} >
                                                    <TSText icon="far fa-edit" name="warantyPeriodYear" label="ระยะประกัน" value={selectedAsset.warantyPeriodYear} onChange={e => handleInputChange(e)} />
                                                </Col>
                                                <Col xs={6} sm={2} md={2} >
                                                    <TSSelect2 label="หน่วย" options={ArrPeriod} value={selectedAsset.warantyPeriodUnit ?? ''} onChange={e => handleSelectChange('warantyPeriodUnit', (e != null ? e.value : '')) } />
                                                </Col>
                                                <Col xs={12} sm={4} md={4}>
                                                        <Label>วันที่หมดประกัน</Label>
                                                        <FormGroup
                                                            style={{ padding: '0 0px', marginBottom: '10px' }}
                                                            className={
                                                                "input-lg" + (/*dateFocus*/false ? " input-group-focus" : "")
                                                            }
                                                        >
                                                            <i className="far fa-calendar-check fa-2x" style={{
                                                                position: 'absolute',
                                                                padding: '5px 0 0 10px',
                                                                zIndex: 1,

                                                            }}
                                                            ></i>

                                                            <Datetime
                                                                value={moment(selectedAsset.warantyExpiredDate).isValid() ? moment(selectedAsset.warantyExpiredDate) : null}
                                                                renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}

                                                                inputProps={{
                                                                    name: "warantyExpiredDate", placeholder: "วันที่หมดประกัน", readOnly: 'readonly'
                                                                    , style: {
                                                                        fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000'
                                                                    },
                                                                    value: moment(selectedAsset.warantyExpiredDate).isValid() ? moment(selectedAsset.warantyExpiredDate).format('D MMMM BBBB') : ''
                                                                }}
                                                                closeOnSelect={true}
                                                                closeOnTab={true}
                                                                dateFormat="D MMMM BBBB" timeFormat={false}
                                                                onFocus={() => setDateFocus(true)}
                                                                onBlur={() => setDateFocus(false)}
                                                                onChange={e => handleSelectChange('warantyExpiredDate', (e != null ? e.format('YYYY-MM-DD') : ''))}

                                                            />
                                                        </FormGroup>
                                                </Col>

                                                <Col xs={12} sm={4} md={4}>
                                                    <TSSelect2 label="ผู้ขาย" options={ArrCompany} value={selectedAsset.companyKey ?? ''} onChange={e => handleSelectChange('companyKey', (e != null ? e.value : '')) } />
                                                </Col>
                                                <Col xs={12} sm={4} md={4}>
                                                    <TSSelect2 label="แหล่งของเงิน" options={ArrKMoney} value={selectedAsset.kmoneyKey ?? ''} onChange={e => handleSelectChange('kmoneyKey', (e != null ? e.value : '')) } />
                                                </Col>
                                                <Col xs={12} sm={4} md={4}>
                                                    <TSSelect2 label="วิธีการได้มา" options={ArrTMoney} value={selectedAsset.tmoneyKey ?? ''} onChange={e => handleSelectChange('tmoneyKey', (e != null ? e.value : '')) } />
                                                </Col>

                                                <Col xs={12} sm={3} md={3}>
                                                    <TSText icon="far fa-edit" name="calYear" label="ปีงบประมาณ" value={selectedAsset.calYear} onChange={e => handleInputChange(e)} />
                                                </Col>
                                                <Col xs={12} sm={3} md={3}>
                                                    <TSText icon="far fa-edit" name="price" label="ราคา" value={selectedAsset.price} onChange={e => handleInputChange(e)} />
                                                </Col>
                                                <Col xs={12} sm={3} md={3}>
                                                        <TSSelect2 label="สถานที่" options={ArrPlace} style={{zIndex:10}} value={selectedAsset.placeKey ?? ''} onChange={e => handleSelectChange('placeKey', (e != null ? e.value : ''))} /> 
                                                </Col>
                                                <Col xs={12} sm={3} md={3}>
                                                    <TSSelect2 label="สถานะ" options={ArrAssetStatus} value={selectedAsset.assetStatusKey ?? ''} onChange={e => handleSelectChange('assetStatusKey', (e != null ? e.value : '')) } /> 
                                                </Col>

                                                    
                                                    <Col xs={12} sm={12} md={12} style={{ zIndex: 0 }}>
                                                        <Card>

                                                            <CardHeader color="primary" style={{ display: 'flex', cursor: 'pointer' }} onClick={() => handleExpand()}>
                                                                <Col xs={6} sm={3} md={2} style={{ float: 'left' }}>
                                                                    <h4 className={classes.cardTitleWhite}>ผู้รับผิดชอบ</h4>
                                                                    {(Attendee != null && Attendee.length > 0) ?
                                                                    <>
                                                                        <p className={classes.cardCategoryWhite}> {Attendee[0].firstName} {Attendee[0].lastName} </p>
                                                                        <p className={classes.cardCategoryWhite}> </p>
                                                                       
                                                                    </> : <></>
                                                                    }
                                                                </Col>

                                                                {(Attendee != null && Attendee.length > 0) ?
                                                                    <Col xs={6} sm={9} md={10}>
                                                                        <img src={'https://e.trangskin.go.th/avatar/' + Attendee[0].userName + '.jpg'} className={classes.cardImg2} />
                                                                    </Col>
                                                                    :
                                                                    <Col xs={6} sm={9} md={10}>
                                                                       &nbsp;
                                                                    </Col>
                                                                }

                                                                <CardActions className={classes.collaps}>
                                                                    <IconButton
                                                                        className={clsx(classes.expand, {
                                                                            [classes.expandOpen]: expanded,
                                                                        })}
                                                                        onClick={() => handleExpand()}
                                                                        aria-expanded={expanded}
                                                                        aria-label="show more"
                                                                    >
                                                                        <ExpandMoreIcon />
                                                                    </IconButton>
                                                                </CardActions>

                                                            </CardHeader>



                                                                <CardBody>
                                                                <Collapse in={expanded} timeout="auto" unmountOnExit>      
                                                                    <Grid>
                                                                        <Col xs={12} sm={12} md={12}>
                                                                            <TSUser value={Attendee} isMultiple={false} isShowAll={false} onChange={e => handleEmployeeChange(e)} />
                                                                        </Col>
                                                                    </Grid>
                                                                </Collapse>
                                                                </CardBody>

                                                            </Card>
                                                        </Col>
                                                       



                                                <Col xs={12} sm={12} md={12} style={{marginTop:'20px'}}>
                                                    <Label>ผู้บันทึก: {selectedAsset.creatorCode} {selectedAsset.createDatetime}</Label>
                                                </Col>
                                                <Col xs={12} sm={12} md={12}>
                                                    <Label>แก้ไขล่าสุด: {selectedAsset.lastEditerCode} {selectedAsset.lastEditDatetime}</Label>
                                                </Col>

                                            </Grid>
                                      
                                        </CardBody>
                                        <CardFooter>

                                        </CardFooter>
                                    </Card>
                                )}
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button2
                                        color="info"
                                        type="button"
                                        onClick={handleSaveChanges}
                                        style={{marginRight:'50px'}}
                                    >
                                        <h4>บันทึก</h4>
                                    </Button2>

                                    <Button2
                                        color="danger"
                                        type="button"
                                        onClick={handleCloseModal}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button2>

                                </div>
                            </Modal>


                            {/* Confirm */}
                            <Modal toggle={() => setModal(false)} isOpen={modal}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center", fontSize: "1.8em"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">

                                    <Button
                                        color="success"
                                        type="button"
                                        //onClick={handleConfirm}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => { setIcon("far fa-question-circle"); setModal(false); }}
                                    >
                                        <i className={"fa fa-thumbs-down"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ยกเลิก</h4>
                                    </Button>


                                </div>
                            </Modal>

                        </CardFooter>
                    </Card>
                </Col>
            </Grid>
        </div>
    );
}



export default AssetList;